import React, { useState } from "react";
import "./rangeSlider.scss";
import { Slider } from "@mui/material";

const RangeSlider = ({
  initialValue = 22,
  min = 5,
  max = 231,
  step = 1,
  unit = "cm",
  label,
  minValue,
  maxValue,
  onChange,
}) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (event, newValue) => {
    if (typeof newValue === "number") {
      setValue(newValue);
    }
    if (onChange) {
      onChange(newValue);
    }
  };

  function valueLabelFormat(value) {
    return `${value}${unit}`;
  }

  return (
    <div className="range">
      <p className="rangeTxt">
        <span>{label}</span>
        <span className="numBg">{`${value}${unit}`}</span>
      </p>
      <Slider
        value={value}
        min={min}
        step={step}
        max={max}
        getAriaValueText={valueLabelFormat}
        valueLabelFormat={valueLabelFormat}
        onChange={handleChange}
        valueLabelDisplay="auto"
        aria-labelledby="non-linear-slider"
      />
      <div className="minMax">
        <span>{minValue}</span>
        <span>{maxValue}</span>
      </div>
    </div>
  );
};

export default RangeSlider;
